import { setCustomerToken } from '@utils/userTokens';
import { useCustomerTokens } from '@hooks/customer/useCustomerTokens';
import useSWRMutation from 'swr/mutation';

const fetcher = () => setCustomerToken(null);

export const useLogout = () => {
  const { mutate } = useCustomerTokens();

  return useSWRMutation('logout', fetcher, {
    onSuccess() {
      mutate();
    },
  });
};
